import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const PhysiqueActiveSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <path
      d="M2.97685 17.134L20.4318 6.70743"
      stroke="url(#paint0_linear-physique)"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.06163 12.9065C0.572017 12.0585 0.862576 10.9741 1.71061 10.4845L3.82193 9.26552C4.66997 8.7759 5.75435 9.06646 6.24396 9.9145L10.9536 18.0719C11.4432 18.9199 11.1527 20.0043 10.3046 20.4939L8.19333 21.7129C7.34529 22.2025 6.26091 21.9119 5.77129 21.0639L1.06163 12.9065Z"
      fill="url(#paint1_linear-physique)"
    />
    <path
      d="M13.0297 5.92514C12.5401 5.0771 12.8307 3.99272 13.6787 3.50311L15.79 2.28413C16.6381 1.79452 17.7224 2.08508 18.212 2.93312L22.9217 11.0905C23.4113 11.9385 23.1208 13.0229 22.2727 13.5125L20.1614 14.7315C19.3134 15.2211 18.229 14.9305 17.7394 14.0825L13.0297 5.92514Z"
      fill="url(#paint2_linear-physique)"
    />
    <defs>
      <linearGradient
        id="paint0_linear-physique"
        x1="-38.9992"
        y1="40.1926"
        x2="-36.5757"
        y2="44.245"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9FB1E1" />
        <stop offset="1" stopColor="#6679BF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear-physique"
        x1="10.5539"
        y1="1.28672"
        x2="19.9973"
        y2="17.6431"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2999E" />
        <stop offset="1" stopColor="#E06065" />
      </linearGradient>
      <linearGradient
        id="paint2_linear-physique"
        x1="10.5539"
        y1="1.28672"
        x2="19.9973"
        y2="17.6431"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2999E" />
        <stop offset="1" stopColor="#E06065" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
